import io from 'socket.io-client';

export
    const socket = io(process.env.REACT_APP_BASE_URL, {
        transports: ["websocket", "polling"],
        withCredentials: true,
        reconnection: true,
        reconnectionAttempts: 2,
        reconnectionDelay: 1000,
    });

socket.on("connect", () => {
    console.log("✅ Connected to WebSocket:", socket.id);
});